import(/* webpackMode: "eager", webpackExports: ["BackgroundImage"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/BackgroundImage/BackgroundImage.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/(landing)/local/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CardsGroup"] */ "/vercel/path0/src/components/CardsGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LocalSelect.tsx");
